(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────────
     CONSTANTS
  ───────────────────────────────────────────────────────────────────────── */
  var GIFT_BAG_VARIANT_ID = '53080330961163';
  var THRESHOLD           = 5900;   // €59.00 in cents
  var SECTION_DELAY_MS    = 500;    // wait after add/remove before section fetch
  var DEBOUNCE_MS         = 200;
  var _variantAvailable = null; // null = unchecked, true = ok, false = unavailable

  /* ─────────────────────────────────────────────────────────────────────────
     MUTEX — only one cart mutation at a time
  ───────────────────────────────────────────────────────────────────────── */
  var _busy        = false;
  var _pendingSync = false;

  function runWhenFree(fn) {
    if (_busy) { _pendingSync = true; return; }
    _busy = true;
    _pendingSync = false;
    Promise.resolve()
      .then(fn)
      .catch(function (e) { console.error('[GiftBag]', e); })
      .then(function () {
        _busy = false;
        if (_pendingSync) { _pendingSync = false; setTimeout(syncGiftBag, 0); }
      });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     DEBOUNCE
  ───────────────────────────────────────────────────────────────────────── */
  var _debounceTimer = null;
  function debouncedSync() {
    if (_debounceTimer) clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(function () { _debounceTimer = null; syncGiftBag(); }, DEBOUNCE_MS);
  }

  /* ─────────────────────────────────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────────────────────────────────── */
  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function formatMoney(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ─────────────────────────────────────────────────────────────────────────
     CART API
  ───────────────────────────────────────────────────────────────────────── */
  function getCart() {
    return fetch('/cart.js?_=' + Date.now(), {
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function addGiftBag() {
      if (_variantAvailable === false) {
          // Variant already confirmed unavailable — skip the network call entirely
              return Promise.resolve(null);
                }
                  return fetch('/cart/add.js', {
                      method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: GIFT_BAG_VARIANT_ID, quantity: 1 })
                                }).then(function (r) {
                                      if (!r.ok) {
                                              _variantAvailable = false; // Cache: don't try again this page load
                                                      console.warn('[GiftBag] addGiftBag failed with status ' + r.status + ': gift bag variant ' + GIFT_BAG_VARIANT_ID + ' may be invalid or not published.');
                                                              return null;
                                                                    }
                                                                          _variantAvailable = true;
                                                                                return r.json();
                                                                                    });
                                                                                    }
                                                                                    
function removeGiftBag(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     THEME CART SECTION RE-RENDER
     Fetches the theme's api-cart-items section and injects HTML into the
     correct DOM holders so the cart line-item list updates live.

     Correct selectors (confirmed from theme.js build() function):
       Line items  → [data-items-holder]         (= #cartItemsHolder)
       Upsell      → [data-pair-products-holder] (= #cartUpsellHolder)
       Price       → [data-cart-price-holder]

     NOTE: does NOT listen to theme:cart:loaded — we dispatch it for the
     theme to re-wire its own event listeners.
  ───────────────────────────────────────────────────────────────────────── */
  function refreshCartSection() {
    var base = (window.theme && window.theme.routes && window.theme.routes.cart_url)
               ? window.theme.routes.cart_url : '/cart';

    return fetch(base + '?section_id=api-cart-items&_=' + Date.now())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var source = tmp.querySelector('[data-api-content]');
        if (!source) {
          console.warn('[GiftBag] api-cart-items: no [data-api-content] found');
          return;
        }

        var newLineItems  = source.querySelector('[data-api-line-items]');
        var newUpsellItems = source.querySelector('[data-api-upsell-items]');
        var newPrice       = source.querySelector('[data-api-cart-price]');

        /* ── Inject line items ── */
        if (newLineItems) {
          document.querySelectorAll('[data-items-holder]').forEach(function (el) {
            el.innerHTML = newLineItems.innerHTML;
            /* Remove 'hidden' class that Liquid adds when cart is empty */
            el.classList.remove('hidden');
          });
        }

        /* ── Inject upsell / pair products ── */
        if (newUpsellItems) {
          document.querySelectorAll('[data-pair-products-holder]').forEach(function (el) {
            el.innerHTML = newUpsellItems.innerHTML;
          });
        }

        /* ── Inject price / subtotal ── */
        if (newPrice) {
          document.querySelectorAll('[data-cart-price-holder]').forEach(function (el) {
            el.innerHTML = newPrice.innerHTML;
          });
        }

        /* Tell the theme to re-wire qty/remove listeners on the new nodes.
           We do NOT listen to this event ourselves to avoid an infinite loop. */
        document.dispatchEvent(new CustomEvent('theme:cart:loaded', { bubbles: true }));
      })
      .catch(function (e) { console.error('[GiftBag] refreshCartSection failed', e); });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     CORE SYNC — the only place that mutates the cart
  ───────────────────────────────────────────────────────────────────────── */
  function syncGiftBag() {
    runWhenFree(function () {
      return getCart().then(function (cart) {
        var items        = cart.items || [];
        var giftBags     = items.filter(function (i) { return String(i.variant_id) === GIFT_BAG_VARIANT_ID; });
        var nonGiftItems = items.filter(function (i) { return String(i.variant_id) !== GIFT_BAG_VARIANT_ID; });
        var subtotal     = nonGiftItems.reduce(function (s, i) { return s + i.line_price; }, 0);

        /* Deduplicate — remove any extras beyond the first */
        if (giftBags.length > 1) {
          var chain = Promise.resolve();
          giftBags.slice(1).forEach(function (extra) {
            chain = chain.then(function () { return removeGiftBag(extra.key); });
          });
          return chain
            .then(function () { return wait(SECTION_DELAY_MS); })
            .then(function () { return Promise.all([refreshCartSection(), getCart()]); })
            .then(function (res) { return applyRules(res[1]); });
        }

        return applyRules(cart);
      });
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     RULES ENGINE
  ───────────────────────────────────────────────────────────────────────── */
  function applyRules(cart) {
    var items        = cart.items || [];
    var bag          = items.find(function (i) { return String(i.variant_id) === GIFT_BAG_VARIANT_ID; }) || null;
    var nonGiftItems = items.filter(function (i) { return String(i.variant_id) !== GIFT_BAG_VARIANT_ID; });
    var subtotal     = nonGiftItems.reduce(function (s, i) { return s + i.line_price; }, 0);
    var qualifies    = subtotal >= THRESHOLD;

    if (qualifies && !bag) {
      /* Rule 1: qualifies, no bag → add it */
      return addGiftBag().then(function (result) {
        if (!result) { renderWidget(cart); return; }
        return wait(SECTION_DELAY_MS)
          .then(function () { return Promise.all([refreshCartSection(), getCart()]); })
          .then(function (res) { renderWidget(res[1]); });
      });

    } else if (!qualifies && bag && bag.price === 0) {
      /* Rule 4: dropped below threshold, bag was free → remove it */
      return removeGiftBag(bag.key)
        .then(function () { return wait(SECTION_DELAY_MS); })
        .then(function () { return Promise.all([refreshCartSection(), getCart()]); })
        .then(function (res) { renderWidget(res[1]); });

    } else {
      /* No mutation needed */
      renderWidget(cart);
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     WIDGET UI — pure display, never mutates the cart
  ───────────────────────────────────────────────────────────────────────── */
  function renderWidget(cart) {
    var widgets = document.querySelectorAll('.gift-bag-widget');
    if (!widgets.length) return;

    var items        = cart.items || [];
    var bag          = items.find(function (i) { return String(i.variant_id) === GIFT_BAG_VARIANT_ID; }) || null;
    var nonGiftItems = items.filter(function (i) { return String(i.variant_id) !== GIFT_BAG_VARIANT_ID; });
    var subtotal     = nonGiftItems.reduce(function (s, i) { return s + i.line_price; }, 0);
    var qualifies    = subtotal >= THRESHOLD;
    var amountNeeded = Math.max(0, THRESHOLD - subtotal);
    var pct          = Math.min(100, Math.round((subtotal / THRESHOLD) * 100));

    widgets.forEach(function (widget) {
      var stFree   = widget.querySelector('.gift-bag-widget__state--free');
      var stUpsell = widget.querySelector('.gift-bag-widget__state--upsell');
      var stAdded  = widget.querySelector('.gift-bag-widget__state--added');

      [stFree, stUpsell, stAdded].forEach(function (el) {
        if (el) el.style.display = 'none';
      });

      if (qualifies) {
        if (stFree) stFree.style.display = '';
      } else if (bag) {
        if (stAdded) {
          stAdded.style.display = '';
          updateProgress(stAdded, amountNeeded, pct);
        }
      } else {
        if (stUpsell) {
          stUpsell.style.display = '';
          updateProgress(stUpsell, amountNeeded, pct);
          wireAddButton(stUpsell);
        }
      }
    });
  }

  function updateProgress(container, amountNeeded, pct) {
    container.querySelectorAll('.gift-bag-widget__amount-needed').forEach(function (el) {
      el.textContent = formatMoney(amountNeeded);
    });
    var bar = container.querySelector('.gift-bag-widget__bar-fill');
    if (bar) bar.style.width = pct + '%';
  }

  function wireAddButton(container) {
    var btn = container.querySelector('.gift-bag-widget__add-btn');
    if (!btn || btn.dataset.wired) return;
    btn.dataset.wired = '1';
    var origText = btn.textContent.trim();

    btn.addEventListener('click', function () {
      if (btn.disabled || _busy) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      runWhenFree(function () {
        return addGiftBag()
          .then(function () { return wait(SECTION_DELAY_MS); })
          .then(function () { return Promise.all([refreshCartSection(), getCart()]); })
          .then(function (res) {
            renderWidget(res[1]);
            btn.disabled = false;
            btn.textContent = origText;
          });
      });
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     MUTATION OBSERVER — re-run widget when cart drawer re-renders its DOM
  ───────────────────────────────────────────────────────────────────────── */
  function observeCartDrawers() {
    ['[data-section-type="cart-drawer"]', '.cart-drawer', '#cart-drawer', '#CartDrawer', 'cart-drawer']
      .forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el || el._giftBagObserved) return;
        el._giftBagObserved = true;
        new MutationObserver(function () { debouncedSync(); })
          .observe(el, { childList: true, subtree: true });
      });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     EVENT LISTENERS
     NOTE: 'theme:cart:loaded' is intentionally NOT listed here.
     We dispatch it inside refreshCartSection() — listening to it
     would create an infinite loop.
  ───────────────────────────────────────────────────────────────────────── */
  document.addEventListener('theme:cart:added',  debouncedSync);
  document.addEventListener('theme:cart:update', debouncedSync);

  /* ─────────────────────────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────────────────────────── */
  function init() {
    syncGiftBag();
    observeCartDrawers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();